export default __webpack_public_path__ + "static/media/Info.ed89e4a9.svg";